import { render, staticRenderFns } from "./SwappTasksPageInfoDialog.vue?vue&type=template&id=089b8b64&scoped=true&"
import script from "./SwappTasksPageInfoDialog.vue?vue&type=script&lang=js&"
export * from "./SwappTasksPageInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089b8b64",
  null
  
)

export default component.exports